<template>
  <div :class="{
    '_disabled': disabled,
    '_request-sent': requestData && requestData.status
  }"
       class="payment-account-open-card">
    <picture v-if="disabled"
             class="payment-account-open-card__logo">
      <img src="@/assets/img/payment/akord.svg"
           alt="Akord">
    </picture>
    <picture v-else
             class="payment-account-open-card__logo">
      <img src="@/assets/img/payment/akord.svg"
           alt="Akord">
    </picture>
    <!--
    <div class="payment-account-open-card__info">
      <BaseSvg name="ico-info"/>
    </div>
    -->
    <template v-if="requestData && requestData.status">
      <div class="payment-account-open-card__text  text  _request-sent">
        <p>{{ $tPayment('The application has been sent') }}</p>
        <p>
          {{ $tPayment('Date of application submission') }}:<br/>
          <b>{{ formatTime(requestData.created_at) }} {{ requestData.created_at | formatDate }}</b>
        </p>
        <p>
          {{ $tPayment('Application number') }}:<br/>
          <b>{{ requestData.order_number }}</b>
        </p>
      </div>

      <button @click.prevent="onCancelOpenPaymentAccount"
              class="payment-account-open-card__cancel-request">
        <BaseSvg name="ico-trash"
                 width="1.4rem"
                 height="1.6rem"/>
        <span>{{ $tPayment('Cancel the application') }}</span>
      </button>

      <BasePreloader v-if="pendingCancelOpen"/>
    </template>

    <template v-else>
      <div class="payment-account-open-card__text  text">
        <p>{{ $tPayment('To open an account, click on the button below') }}</p>
      </div>
      <div class="payment-account-open-card__btns">
        <button @click.prevent="onOpenPaymentAccount"
                class="payment-account-open-card__btn  base-btn  base-btn--blue">
          <BasePreloader v-if="pendingOpen"
                         class="_small"/>
          <span>{{ $tPayment('Open an account') }}</span>
          <BaseSvg name="ico-arrow-light" width="1rem" height="0.8rem"/>
        </button>
        <!--<button class="payment-account-open-card__btn  _has-account  inline-link">
          {{ $tPayment('В мене вже є рахунок') }}
        </button>-->
      </div>
    </template>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import handleError from '@/helpers/handleError'
  import {formatTime} from '@/helpers/formatDate'

  export default {
    name: 'PaymentAccountOpenCardAkord',
    props: {
      disabled: Boolean,
      requestData: {
        status:0,
        order_number:null,
        created_at:null,
        account_data:null
      },
    },
    data() {
      return {
        pendingOpen: false,
        pendingCancelOpen: false,
      }
    },
    computed: {

    },
    methods: {
      onOpenPaymentAccount() {
        this.pendingOpen = true

        http.post('/api/jobian-pay/send-accord')
          .then(({data}) => {
            this.$emit('after-open', data)

            this.$vModal.open('payment-account-message', {
              text: '<p><b>'+this.$tPayment('The application has been sent')+'</b><br>'+this.$tPayment('An Accord Bank employee contact')+'</p>'
            })
          })
          .catch(e => {
            const error = handleError(e)

            this.$vModal.open('warning', {
              title: error
            })
          })
          .finally(() => {
            this.pendingOpen = false
          })
      },
      onCancelOpenPaymentAccount() {
        this.$vModal.open('payment-account-cancel-request', {
          onSuccess: () => {
            this.requestData.status = 0
            this.$emit('after-cancel-open', this.requestData)
          }
        })
      },
      formatTime
    }
  }
</script>

<style lang="less">

</style>
